import { createBrowserRouter } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import AdminPage from '../pages/Admin';
import DiagnosisPage from '../pages/Diagnosis';
import HomePage from '../pages/Home';
import ReportPage from '../pages/Report';
import SharePage from '../pages/Share';

const layoutChildren = [
  { index: true, element: <HomePage /> },
  { path: 'diagnosis/:id', element: <DiagnosisPage /> },
  { path: 'report/:id', element: <ReportPage /> },
  { path: 'report/share/:token', element: <SharePage /> },
  { path: 'admin', element: <AdminPage /> },
];

export const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: layoutChildren,
  },
]);
